import { ByTitleForm } from './ByTitleForm'
import { withByTitleForm } from './withByTitleForm'

const ConnectedByTitleForm = withByTitleForm(ByTitleForm)

export { ConnectedByTitleForm as ByTitleForm }
